import { IContactTemp } from "../../../models/index";

export interface IGalaContactsState {
    list: IContactTemp[];
}